import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useCallback } from 'react';

const useTransferWorkspaceMutations = () => {
  const { enqueueSnackbar } = useSnackbar();

  const request = useCallback(
    (promise, { successMessage } = {}) =>
      promise
        .then(res => {
          if (res.status === 200) {
            if (successMessage) {
              enqueueSnackbar(successMessage, { variant: 'success' });
            }
            return res.data?.value ?? true;
          }
          enqueueSnackbar(res?.message, { variant: 'error' });
          return null;
        })
        .catch(err => {
          enqueueSnackbar(err?.message || err?.response?.data?.message, {
            variant: 'error',
          });
          return null;
        }),
    [enqueueSnackbar],
  );

  const submitOperation = useCallback(
    operationGuid =>
      request(
        axiosClient.put('Operation/Submit', null, {
          params: { GUID: operationGuid },
        }),
        { successMessage: 'عملیات با موفقیت اتمام شد' },
      ),
    [request],
  );

  return {
    submitOperation,
  };
};

export default useTransferWorkspaceMutations;
